/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { IVisitable } from '../IVisitable';

/**
 * A property schema.
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface IPropertySchema extends IVisitable {
    /**
     * Returns the property schema's name.
     * @return {string}
     */
    getPropertyName() : string;

    /**
     * Renames the property schema.
     * @param {string} newName
     */
    rename(newName : string);
}


